(function () {
  var S = window.SR || {};
  var T = S.t || {};
  var R = S.routes || { cart: '/cart', add: '/cart/add', change: '/cart/change' };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var body = document.body;

  function money(c) {
    var v = (c || 0) / 100, f = S.moneyFormat || '${{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return Math.round(v).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return v.toFixed(2).replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(v).toLocaleString('de-DE');
      return v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>'"]/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
  function toast(t) {
    var el = document.querySelector('.sr-toast');
    if (!el) { el = document.createElement('div'); el.className = 'sr-toast'; el.setAttribute('role', 'status'); body.appendChild(el); }
    el.textContent = t; el.classList.add('is-on');
    clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('is-on'); }, 2800);
  }
  function fail(e) { toast((e && (e.description || e.message)) || T.error || 'Please try again.'); }

  /* Reveal on scroll */
  var rv = document.querySelectorAll('.sr-reveal');
  if (!('IntersectionObserver' in window) || reduce) { rv.forEach(function (e) { e.classList.add('is-in'); }); }
  else {
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    rv.forEach(function (e) { io.observe(e); });
  }

  /* Menu */
  var menu = document.querySelector('[data-sr-menu]');
  var scrim = document.querySelector('[data-sr-scrim]');
  var burger = document.querySelector('[data-sr-burger]');
  function setMenu(o) {
    if (!menu) return;
    menu.classList.toggle('is-open', o);
    if (scrim) scrim.classList.toggle('is-on', o);
    body.classList.toggle('sr-lock', o);
    if (burger) burger.setAttribute('aria-expanded', o ? 'true' : 'false');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sr-burger]')) { setMenu(true); return; }
    if (e.target.closest('[data-sr-close-menu]') || e.target.closest('[data-sr-scrim]')) { setMenu(false); return; }
    var mb = e.target.closest('[data-sr-mega-btn]');
    if (mb) {
      var li = mb.parentElement, o = !li.classList.contains('is-open');
      li.classList.toggle('is-open', o); mb.setAttribute('aria-expanded', o ? 'true' : 'false');
      return;
    }
    if (menu && menu.classList.contains('is-open') && e.target.closest('[data-sr-menu] a')) setMenu(false);
    document.querySelectorAll('.sr-has-mega.is-open').forEach(function (li) { if (!li.contains(e.target)) { li.classList.remove('is-open'); var b = li.querySelector('[data-sr-mega-btn]'); if (b) b.setAttribute('aria-expanded', 'false'); } });
  });

  /* Cart */
  var drawer = document.querySelector('[data-sr-drawer]');
  function json(r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); }
  function getCart() { return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } }).then(json); }
  function change(key, q) { return fetch(R.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) }).then(json); }
  function lineHTML(it) {
    var img = it.image ? "<img src='" + esc(it.image) + "' alt='' width='76' height='76' loading='lazy'>" : '<span></span>';
    var vt = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small>' : '';
    var disc = (it.line_level_discount_allocations || []).map(function (d) { return "<span class='sr-line__disc'>" + esc(d.discount_application && d.discount_application.title || '') + ' (−' + money(d.amount) + ')</span>'; }).join('');
    var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
    return "<div class='sr-line' data-key='" + esc(it.key) + "'>" + img + '<div><h3><a href=\'' + esc(it.url) + '\'>' + esc(it.product_title) + '</a></h3>' + vt + disc +
      "<div class='sr-qty'><button type='button' data-sr-dec aria-label='Decrease'>−</button><input type='number' min='0' value='" + it.quantity + "' aria-label='Quantity' data-sr-q><button type='button' data-sr-inc aria-label='Increase'>+</button></div>" +
      "<button type='button' class='sr-rm' data-sr-rm>" + esc(T.remove || 'Remove') + "</button></div><div class='sr-line__p'>" + money(it.final_line_price) + was + '</div></div>';
  }
  function render(cart) {
    document.querySelectorAll('[data-sr-count]').forEach(function (c) { c.textContent = cart.item_count; if (cart.item_count) c.removeAttribute('data-empty'); else c.setAttribute('data-empty', ''); });
    document.querySelectorAll('[data-sr-items]').forEach(function (box) {
      box.innerHTML = cart.item_count ? cart.items.map(lineHTML).join('') :
        "<div class='sr-empty'><h3>" + esc(T.emptyTitle || '') + "</h3><p></p><a class='sr-btn' href='" + esc(S.emptyLink || '/') + "'>" + esc(T.emptyBtn || '') + '</a></div>';
    });
    document.querySelectorAll('[data-sr-subtotal]').forEach(function (s) { s.textContent = money(cart.total_price); });
    var saved = cart.total_discount || 0;
    document.querySelectorAll('[data-sr-saved]').forEach(function (s) { s.hidden = !saved; var v = s.querySelector('[data-sr-saved-v]'); if (v) v.textContent = '−' + money(saved); });
    document.querySelectorAll('[data-sr-foot]').forEach(function (f) { f.hidden = !cart.item_count; });
    return cart;
  }
  function refresh() { return getCart().then(render); }
  function openCart() {
    if (!drawer) { location.href = R.cart; return; }
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); body.classList.add('sr-lock');
    var c = drawer.querySelector('.sr-drawer__head [data-sr-close-cart]'); if (c) c.focus();
  }
  function closeCart() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); body.classList.remove('sr-lock'); }
  function setQty(line, q) { line.classList.add('is-busy'); change(line.getAttribute('data-key'), q).then(render).catch(function (e) { line.classList.remove('is-busy'); fail(e); }); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sr-open-cart]')) { if (drawer && S.cartType !== 'page') { e.preventDefault(); refresh(); openCart(); } return; }
    if (e.target.closest('[data-sr-close-cart]')) { closeCart(); return; }
    var line = e.target.closest('[data-sr-items] .sr-line');
    if (line) {
      var inp = line.querySelector('[data-sr-q]'), q = +inp.value || 0;
      if (e.target.closest('[data-sr-inc]')) setQty(line, q + 1);
      else if (e.target.closest('[data-sr-dec]')) setQty(line, Math.max(0, q - 1));
      else if (e.target.closest('[data-sr-rm]')) setQty(line, 0);
    }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-sr-items] [data-sr-q]')) setQty(e.target.closest('.sr-line'), Math.max(0, +e.target.value || 0));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); setMenu(false); } });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('[data-sr-form]')) return;
    if (f.getAttribute('data-sr-checkout') === 'true' || !drawer || S.cartType === 'page') return;
    e.preventDefault();
    var btn = f.querySelector('[data-sr-atc]'); if (btn) btn.disabled = true;
    fetch(R.add + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(json).then(refresh).then(openCart).catch(fail)
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* Product page */
  var pdp = document.querySelector('[data-sr-product]');
  if (pdp) {
    var track = pdp.querySelector('[data-sr-track]');
    var thumbs = [].slice.call(pdp.querySelectorAll('[data-sr-thumb]'));
    var counter = pdp.querySelector('[data-sr-counter]');
    function goImg(n) { if (track) track.scrollTo({ left: n * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
    thumbs.forEach(function (th) { th.addEventListener('click', function () { goImg(+th.getAttribute('data-sr-thumb')); }); });
    if (track) track.addEventListener('scroll', function () {
      var n = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      thumbs.forEach(function (th, k) { th.classList.toggle('is-active', k === n); });
      if (counter) counter.textContent = (n + 1) + ' / ' + track.children.length;
    }, { passive: true });

    var form = pdp.querySelector('[data-sr-form]');
    var qty = form && form.querySelector('[name=quantity]');
    var packs = [].slice.call(pdp.querySelectorAll('[data-sr-pack]'));
    var label = S.btnLabel || 'Checkout';
    function setPack(inp) {
      if (!inp) return;
      inp.checked = true;
      packs.forEach(function (p) { p.closest('.sr-pk').classList.toggle('is-on', p === inp); });
      if (qty) qty.value = inp.value;
      var tot = inp.getAttribute('data-total'), was = inp.getAttribute('data-was');
      document.querySelectorAll('[data-sr-total]').forEach(function (el) { el.textContent = tot; });
      document.querySelectorAll('[data-sr-was]').forEach(function (el) { el.textContent = was || ''; el.hidden = !was; });
      document.querySelectorAll('[data-sr-atc]').forEach(function (b) { if (!b.disabled) b.textContent = label + ' · ' + tot; });
    }
    packs.forEach(function (p) { p.addEventListener('change', function () { setPack(p); }); });
    var want = new URLSearchParams(location.search).get('pack');
    var start = packs.filter(function (p) { return p.value === want; })[0] || packs.filter(function (p) { return p.checked; })[0] || packs[0];
    setPack(start);

    var sticky = document.querySelector('[data-sr-sticky]');
    var mainBtn = pdp.querySelector('[data-sr-atc]');
    if (sticky && mainBtn && form && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { var e0 = en[0]; sticky.classList.toggle('is-on', !e0.isIntersecting && e0.boundingClientRect.top < 0); }).observe(mainBtn);
      sticky.querySelector('[data-sr-sticky-add]').addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(mainBtn); else mainBtn.click(); });
    }
  }

  window.SRCart = { refresh: refresh, open: openCart, close: closeCart, money: money, toast: toast };
  refresh().catch(function () {});
})();
